import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import VideoLogo from './VideoLogo';
import DialecticaLogo from '../../icons/DialecticaLogo';
import { useAppState } from '../../state';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';
import InviteButton from '../CallInvite/InviteButton';
import TroubleshootButton from '../Buttons/TroubleshootButton';

const Background = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#191b1d',
  height: '100%',
});

const Container = styled('div')({
  position: 'relative',
  flex: '1',
});

const InnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '888px',
  minHeight: '379px',
  borderRadius: '8px',
  boxShadow: '0px 2px 4px 0px rgba(40, 42, 43, 0.3)',
  overflow: 'hidden',
  position: 'relative',
  margin: 'auto',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
    height: 'auto',
    width: 'calc(100% - 40px)',
    margin: 'auto',
    maxWidth: '400px',
  },
}));

const SwooshContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#10416D',
  width: '296px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100px',
    backgroundPositionY: '140px',
  },
}));

const LogoContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  width: '210px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    alignItems: 'center',
    width: '90%',
    textAlign: 'initial',
    '& svg': {
      height: '64px',
    },
  },
}));

const Content = styled('div')(({ theme }) => ({
  background: 'white',
  width: '100%',
  padding: '4em',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    padding: '2em',
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: 'white',
  margin: '1em 0 0',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    fontSize: '1.1rem',
  },
}));

const StyledDialecticaLogo = styled(DialecticaLogo)({
  top: '10px',
  left: '1em',
  position: 'absolute',
  height: '40px',
});

const FooterContainer = styled('div')({
  position: 'absolute',
  bottom: 0,
  margin: '1em',
  display: 'flex',
  alignItems: 'center',
  '& a': {
    color: 'white',
  },
});

const FooterLeftContainer = styled(FooterContainer)({
  left: 0,
});

const FooterRightContainer = styled(FooterContainer)({
  right: 0,
});

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const { user } = useAppState();
  const location = useLocation();

  return (
    <Background>
      <StyledDialecticaLogo />
      {user && location.pathname !== '/login' && <UserMenu />}
      <Container>
        <InnerContainer>
          <SwooshContainer>
            <LogoContainer>
              <VideoLogo />
              <Title variant="h6">
                Join Meeting
              </Title>
            </LogoContainer>
          </SwooshContainer>
          <Content>{props.children}</Content>
        </InnerContainer>
      </Container>
      <FooterLeftContainer> <TroubleshootButton /> </FooterLeftContainer>
      {user && location.pathname !== '/login' && <FooterRightContainer> <InviteButton /> </FooterRightContainer>}
    </Background>
  );
};

export default IntroContainer;
